@if (!config.hideCard) {
    <widget-card [cardTitle]="config.translations.widgetTitle">
        <div [innerHTML]="html$ | async | safe: 'html'"></div>
    </widget-card>
} @else {
    <div [innerHTML]="html$ | async | safe: 'html'"></div>
}
